import { create } from 'zustand';
import { Clinician } from '../types';

interface ClinicianStore {
  clinicians: Clinician[];
  selectedClinician: Clinician | null;
  setSelectedClinician: (clinician: Clinician | null) => void;
  addClinician: (clinician: Clinician) => void;
  updateClinician: (id: string, updates: Partial<Clinician>) => void;
  transferClinician: (clinicianId: string, newGroupId: string) => void;
}

export const useClinicianStore = create<ClinicianStore>((set) => ({
  clinicians: [],
  selectedClinician: null,
  setSelectedClinician: (clinician) => set({ selectedClinician: clinician }),
  addClinician: (clinician) => {
    // Ensure required fields
    if (!clinician.email) {
      throw new Error('Clinician must have an email');
    }

    set((state) => ({
      clinicians: [...state.clinicians, clinician],
    }));
  },
  updateClinician: (id, updates) => {
    set((state) => ({
      clinicians: state.clinicians.map((c) =>
        c.id === id ? { ...c, ...updates } : c
      ),
    }));
  },
  transferClinician: (clinicianId, newGroupId) => {
    if (!newGroupId) {
      throw new Error('New group ID is required for transfer');
    }

    set((state) => ({
      clinicians: state.clinicians.map((c) =>
        c.id === clinicianId
          ? {
              ...c,
              groupId: newGroupId,
              billingStatus: 'pending',
            }
          : c
      ),
    }));
  },
}));